<div class="row justify-content-md-center" *ngIf="app.config!=null">
    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
        <div class="card floating shadow-lg">
            <div class="card-body">
                <h3 class="card-title main-title">Change Password</h3>
                <div class="row">
                    <div class="col">
                        <div class="form-control-plaintext">
                            Please enter current password and your new password.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Current Password*</mat-label>
                            <input matInput [(ngModel)]="oldPassword" type="password">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>New Password*</mat-label>
                            <input matInput [(ngModel)]="newPassword" type="password">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-form-field appearance="outline">
                            <mat-label>Confirm New Password*</mat-label>
                            <input matInput [(ngModel)]="confirmNewPassword" type="password">
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="row card-footer">
                <div class="col text-center">
                    <a class="btn btn-blue" (click)="submit()">Update Password</a>
                </div>
            </div>
        </div>
    </div>
</div>